const jobsData = [
    {
      id: "694153bc73cc62ccd5cbbd01",
      title: "Full Stack Developer",
      experience: "0–1 Years",
      salary: "10k - 20k/month",
      location: "Remote",
      type: "Full-time",
      skills: ["React", "Node.js", "MongoDB", "AWS" , "JavaScript" , "HTML" , "CSS" , "Git" , "GitHub" , "Tailwind CSS"],
      shortDescription:
        "Build and scale our influencer marketing platform using modern technologies.",
      fullDescription:
        "Join our engineering team to build scalable systems that power influencer marketing at scale.", 
      responsibilities: [
        "Develop frontend features using React",
        "Develop backend features using Node.js",
        "Build REST APIs with Node.js",
        "Optimize database queries using MongoDB",
        "Collaborate with product and design teams"
      ],
      requirements: [
        "Strong JavaScript fundamentals",
        "Some experience with MERN stack",
        "Good understanding of React.js and Node.js frameworks and libraries like Redux, Express.js, etc.",
        "Basic system design understanding"
      ]
    },
    {
      id: "694153bc73cc62ccd5cbbd02",
      title: "Business Development (Sales) - Internship",
      experience: "0–1 Years",
      salary: "5k - 10k/month (Stipend)",
      location: "Remote",
      type: "Internship",
      skills: ["Sales", "Marketing", "Business Development", "Communication", "Negotiation", "Time Management", "English Proficiency (Spoken & Written)"],
      shortDescription:
        "We are looking for a Business Development (Sales) Intern to help us grow our business.",
      fullDescription:
        "We are looking for a Business Development (Sales) Intern to help us grow our business.", 
      responsibilities: [
        "can start the work from home job/internship between 13th Jan'26 and 17th Feb'26",
        "Identify and qualify potential clients",
        "Build relationships with potential clients",
        "Follow up with potential clients",
        "Book meetings with potential clients",
        "have relevant skills and interests",
        "Women wanting to start/restart their career can also apply."
      ],
      requirements: [
        "Excellent spoken and written English",
        "Strong sales and persuasion skills",
        "Comfortable speaking to clients on calls, chats, and emails",
        "Organized, confident, and professional",
        "Experience in sales, marketing, or client handling is a plus",
        "Familiarity with digital platforms, influencers, or online marketing is a bonus"
      ]
    },
    {
      id: "694153bc73cc62ccd5cbbd03",
      title: "Human Resource (HR)",
      experience: "0–1 Years",
      salary: "10k - 15k/month",
      location: "Remote",
      type: "Full-time",
      skills: ["HR", "Recruitment", "Employee Management", "Communication", "Time Management", "Problem Solving"],
      shortDescription: "Manage HR operations and employee lifecycle. Good communication skills and basic HR knowledge.",
      fullDescription:
        "You will manage HR operations including recruitment, onboarding, and employee engagement. Good communication skills and basic HR knowledge.",
      responsibilities: [
        "Manage HR operations",
        "Handle recruitment process"
      ],
      requirements: [
        "Basic HR knowledge",
        "Good communication skills"
      ]   
    }
  ];
  
  export default jobsData;
  